import "./ClientSuccessScreen.scss";
import React, {useCallback} from "react";
import SuccessPopupComponent from "../../shared/components/success-popup/SuccessPopupComponent";
import {useSearchParams} from "react-router-dom";
import ButtonComponent from "../../shared/components/button/ButtonComponent";

interface ClientInjuryDetailsScreenProps {

}

const ClientSuccessScreen = (props: ClientInjuryDetailsScreenProps) => {

    const [searchParams] = useSearchParams();
    const context = searchParams.get('context');
    let description;
    if (context === 'injury-form') {
        description = 'Congratulations, you have completed New Injury/Condition Information.';
    } else if (context === 'client-registration') {
        description = 'Congratulations, you have completed your Portal Registration.';
    } else {
        description = 'Congratulations!';
    }

    const handleClick = useCallback(() => {
        window.open('https://www.zoella.health/', '_self');
    }, []);


    return (
        <div className={'client-injury-success-screen'}>
            <div className={'client-injury-details-success-popup-wrapper'}>
                <SuccessPopupComponent
                    description={description}
                    actions={<>
                        <div className={'success-popup-cta'}>
                            <ButtonComponent onClick={handleClick}>
                                Learn more
                            </ButtonComponent>
                        </div>
                    </>}
                />
            </div>
        </div>
    );

};

export default ClientSuccessScreen;
